const ENDPOINTS = {
  EU: "https://d.eu.criteo.com/delivery/retailmedia",
  US: "https://d.us.criteo.com/delivery/retailmedia",
};

const criteoConfig = {
  partnerId: {
    GB: { prod: 100712, testEnv: 101298 },
    FR: { prod: 100714, testEnv: 102301 },
    DE: { prod: 100715, testEnv: 102302 },
    US: { prod: 100716, testEnv: 999999 },
  },
  endPoints: {
    GB: ENDPOINTS.EU,
    FR: ENDPOINTS.EU,
    DE: ENDPOINTS.EU,
    US: ENDPOINTS.US,
  },
  experimentKey: "pdp-google-ads-vs-criteo-spotlight-ads",
};

export default criteoConfig;
